import styled from 'styled-components';
import gplayImgUrl from 'assets/images/gplay-link.png';
import appStoreImgUrl from 'assets/images/app-store-link.png';

export const PlaylistLinks = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: center;
  padding: 12px 0;
  background-color: ${({ theme }) => theme.background};
  box-shadow: 0 0px 3px 0 ${({ theme }) => theme.footerBoxShadowColor};
  z-index: 9;

  a:first-child {
    margin-right: 12px;
  }
`;

export const GooglePlayImage = styled.img.attrs({
  src: gplayImgUrl,
  alt: 'Google play',
})`
  height: 30px;
`;

export const AppStoreImage = styled.img.attrs({
  src: appStoreImgUrl,
  alt: 'App store',
})`
  height: 30px;
`;
